const PENDING_SIGNUP_USERNAME_KEY = "cognito_pending_signup_username";
const PENDING_SIGNUP_TTL_MS = 5 * 60 * 1000; // 5 minutes

interface PendingSignUpData {
  username: string;
  expiresAt: number;
}

export function setPendingSignUpUsername(username: string): void {
  const data: PendingSignUpData = {
    username,
    expiresAt: Date.now() + PENDING_SIGNUP_TTL_MS,
  };
  localStorage.setItem(PENDING_SIGNUP_USERNAME_KEY, JSON.stringify(data));
}

export function getPendingSignUpUsername(): string | undefined {
  const raw = localStorage.getItem(PENDING_SIGNUP_USERNAME_KEY);
  if (!raw) {
    return undefined;
  }

  try {
    const data: PendingSignUpData = JSON.parse(raw);
    if (Date.now() > data.expiresAt) {
      localStorage.removeItem(PENDING_SIGNUP_USERNAME_KEY);
      return undefined;
    }
    return data.username;
  } catch {
    localStorage.removeItem(PENDING_SIGNUP_USERNAME_KEY);
    return undefined;
  }
}

export function clearPendingSignUpUsername(): void {
  localStorage.removeItem(PENDING_SIGNUP_USERNAME_KEY);
}
